import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import client from '../../sanityClient'


const CategoryCard = ({ category }) => {
    return (
        <Link
            to={`/category/${category.title.toLowerCase().replace(/\s+/g, '-')}`}
            className="block group"
        >
            <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:scale-105">
                <div className="p-6">
                    <h2 className="text-xl font-semibold text-gray-800">{category.title}</h2>
                </div>
            </div>
        </Link>
    )
}

export default function CategoryListPage() {
    const [categories, setCategories] = useState ([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState (null)

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const data = await client.fetch(`
          *[_type == "category"] {
            _id,
            title
          }
        `)
                const uniqueCategories = Array.from(new Set(data.map(c => c.title)))
                    .map(title => data.find(c => c.title === title))
                setCategories(uniqueCategories)
                setLoading(false)
            } catch (err) {
                console.error('Error fetching categories:', err)
                setError('Failed to load categories. Please try again later.')
                setLoading(false)
            }
        }

        fetchCategories()
    }, [])

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="min-h-screen bg-gray-100 flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-red-600 mb-4">Error</h1>
                    <p className="text-gray-700">{error}</p>
                </div>
            </div>
        )
    }

    return (
        <div className="bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <h1 className="text-3xl font-extrabold text-gray-900 text-center mb-10">
                    Explore Our Blog Categories
                </h1>
                <p className="text-xl text-gray-600 text-center mb-12">
                    Discover a wealth of knowledge across our diverse range of topics
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {categories.map((category) => (
                        <CategoryCard key={category._id} category={category} />
                    ))}
                </div>
            </div>
        </div>
    )
}